import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LoginPage } from '../login/login';

/**
 * Generated class for the PresignupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-presignup',
  templateUrl: 'presignup.html',
})
export class PresignupPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PresignupPage');
  }

  login(){
    this.navCtrl.push(LoginPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/presignup/presignup.ts